import React from "react";
import { CustomTextAreaProps } from "./types";

const CustomTextArea: React.FC<CustomTextAreaProps> = ({
  maxLength,
  placeholder,
  value,
  onChange,
  id,
  className = "",
}) => {
  return (
    <div className="w-full max-w-md relative">
      <textarea
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        maxLength={maxLength}
        className={`[border:none] resize-none bg-[#6B96D626] h-[120px] w-full [outline:none] rounded-xl flex flex-col items-start justify-start py-3 px-4 box-border font-public-sans italic font-extralight text-[16px] text-[#DBCDFD] placeholder:text-[#DBCDFD] ${className}`}
        rows={6}
        cols={58}
      />
      <div className="flex justify-between absolute right-[15px] bottom-[10px] items-center text-[12px] font-normal text-[#6B96D6] mt-2">
        <span>
          {value.length}/{maxLength}
        </span>
      </div>
    </div>
  );
};

export default CustomTextArea;
